export default "__VITE_ASSET__B8uKyPpT__"